import script from "./OpinionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OpinionCard.vue?vue&type=script&setup=true&lang=js"

import "./OpinionCard.vue?vue&type=style&index=0&id=086d585a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-086d585a"]])

export default __exports__